var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNoMessages(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 40,
    viewBox: "0 0 40 40",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_250_10529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 18.3334V15.0001L6.66666 11.6667V28.6167L8.61666 26.6667H21.6667L13.3333 18.3334H10ZM13.3333 23.3334H10V20.0001H13.3333V23.3334ZM33.3333 6.66675H11.1L16.6667 12.2334V10.0001H30V13.3334H17.7667L19.4333 15.0001H30V18.3334H22.7667L31.1 26.6667H33.3333V6.66675Z",
    fill: "#F3F4F5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M33.3333 6.66657V26.6666H31.1L34.2833 29.8499C35.65 29.4332 36.6667 28.1666 36.6667 26.6666V6.66657C36.6667 4.83324 35.1667 3.33324 33.3333 3.33324H7.76667L11.1 6.66657H33.3333ZM10 19.9999H13.3333V23.3332H10V19.9999ZM30 18.3332V14.9999H19.4333L22.7667 18.3332H30ZM30 13.3332V9.9999H16.6667V12.2332L17.7667 13.3332H30ZM2.35 2.6499L0 4.9999L3.33333 8.3499V36.6666L10 29.9999H25L34.55 39.5499L36.9 37.1999L2.35 2.6499ZM8.61667 26.6666L6.66667 28.6166V11.6666L10 14.9999V18.3332H13.3333L21.6667 26.6666H8.61667Z",
    fill: "#8D99A8"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_250_10529"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 40,
    height: 40,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoMessages);
export default __webpack_public_path__ + "static/media/no-messages.3235d767.svg";
export { ForwardRef as ReactComponent };